tinymce.addI18n("sq", {
    "#": "#",
    "Accessibility": "P\xebrdorim nga persona me aft\xebsi t\xeb kufizuara",
    "Accordion": "Fizarmonik\xeb",
    "Accordion body...": "Trupi i fizarmonik\xebs...",
    "Accordion summary...": "P\xebrmbledhja e fizarmonik\xebs...",
    "Action": "Veprim",
    "Activity": "Veprimtari",
    "Address": "Adres\xeb",
    "Advanced": "T\xeb m\xebtejshme",
    "Align": "Vendose",
    "Align center": "V\xebre n\xeb qend\xebr",
    "Align left": "V\xebre majtas",
    "Align right": "V\xebre djathtas",
    "Alignment": "Drejtim",
    "Alignment {0}": "Rreshtim {0}",
    "All": "Krejt",
    "Alternative description": "P\xebrshkrim alternativ",
    "Alternative source": "Burim alternativ",
    "Alternative source URL": "URL burimi alternativ",
    "Anchor": "Spiranc\xeb",
    "Anchor...": "Spiranc\xeb\u2026",
    "Anchors": "Spiranca",
    "Animals and Nature": "Kafsh\xeb & Natyr\xeb",
    "Arrows": "Shigjeta",
    "B": "B",
    "Background color": "Ngjyr\xeb sfondi",
    "Background color {0}": "Sfond me ngjyr\xeb t\xeb {0}",
    "Black": "E zez\xeb",
    "Block": "Bllokoje",
    "Block {0}": "Bllok {0}",
    "Blockquote": "Citat",
    "Blocks": "Blloqe",
    "Blue": "E kalt\xebr",
    "Blue component": "Ngjyra e kuqe",
    "Body": "L\xebnd\xeb",
    "Bold": "T\xeb trasha",
    "Border": "An\xeb",
    "Border color": "Ngjyr\xeb ane",
    "Border style": "Stil an\xebsh",
    "Border width": "Gjer\xebsi an\xebsh",
    "Bottom": "N\xeb fund",
    "Browse files": "Shfletoni dosjet",
    "Browse for an image": "Shfletoni p\xebr nj\xeb figur\xeb",
    "Browse links": "Shfletoni linqet",
    "Bullet list": "List\xeb me toptha",
    "Cancel": "Anuloje",
    "Caption": "Legjend\xeb",
    "Cell": "Kutiz\xeb",
    "Cell padding": "Mbushje kutize",
    "Cell properties": "Veti kutize",
    "Cell spacing": "Hap\xebsir\xeb kutize",
    "Cell styles": "Pamja e qelizave",
    "Cell type": "Lloj kutize",
    "Center": "N\xeb qend\xebr",
    "Characters": "Shenja",
    "Characters (no spaces)": "Shenja (pa hap\xebsira)",
    "Circle": "Rreth",
    "Class": "Klas\xeb",
    "Clear formatting": "Spastroju formatimin",
    "Close": "Mbylle",
    "Code": "Kod",
    "Code sample...": "Shembull kodi\u2026",
    "Code view": "Parje kodi",
    "Color Picker": "Zgjedh\xebs Ngjyrash",
    "Color swatch": "Palet\xeb ngjyrash",
    "Cols": "Shtylla",
    "Column": "Shtyll\xeb",
    "Column clipboard actions": "Veprimet e clipboard-it n\xeb kolona",
    "Column group": "Grup shtyllash",
    "Column header": "Kreu i kolon\xebs",
    "Constrain proportions": "Mbaji detyrimisht p\xebrpjestimet",
    "Copy": "Kopjoje",
    "Copy column": "Kopjo kolon\xebn",
    "Copy row": "Kopjoje rreshtin",
    "Could not find the specified string.": "S\u2019u gjet dot vargu i dh\xebn\xeb.",
    "Could not load emojis": "Emoji-t nuk mund t\xeb ngarkoheshin",
    "Count": "Num\xebr",
    "Currency": "Monedh\xeb",
    "Current window": "Dritaren e tanishme",
    "Custom color": "Ngjyr\xeb vetjake",
    "Custom...": "Vetjake\u2026",
    "Cut": "Prije",
    "Cut column": "Shkoq kolon\xebn",
    "Cut row": "Prije rreshtin",
    "Dark Blue": "Blu e Err\xebt",
    "Dark Gray": "Gri e Err\xebt",
    "Dark Green": "E gjelb\xebr e Err\xebt",
    "Dark Orange": "Portokalli e Err\xebt",
    "Dark Purple": "E purpurt e Err\xebt",
    "Dark Red": "E kuqe e Err\xebt",
    "Dark Turquoise": "E bruzt\xeb e Err\xebt",
    "Dark Yellow": "E verdh\xeb e Err\xebt",
    "Dashed": "Me viza",
    "Date/time": "Dat\xeb/koh\xeb",
    "Decrease indent": "Zvog\xeblo kryeradh\xebn",
    "Default": "Parazgjedhje",
    "Delete accordion": "Hiqe fizarmonik\xebn",
    "Delete column": "Fshi shtyll\xeb",
    "Delete row": "Fshije rreshtin",
    "Delete table": "Fshi tabel\xebn",
    "Dimensions": "P\xebrmasa",
    "Disc": "Disk",
    "Div": "Div",
    "Document": "Dokument",
    "Dotted": "Me pika",
    "Double": "E dyfishuar",
    "Drop an image here": "Lini k\xebtu nj\xeb figur\xeb",
    "Dropped file type is not supported": "Lloji i dosjes s\xeb l\xebshuar nuk \xebsht\xeb i p\xebrkrahur",
    "Edit": "P\xebrpunoni",
    "Embed": "Trup\xebzojeni",
    "Emojis": "Emoji-t",
    "Emojis...": "Emoji-t...",
    "Error": "Gabim",
    "Error: Form submit field collision.": "Gabim: P\xebrplasje fushash parashtrimi formulari.",
    "Error: No form element found.": "Gabim: S\u2019u gjet element forme.",
    "Extended Latin": "Latinishte e Zgjeruar",
    "Failed to initialize plugin: {0}": "S\u2019u arrit t\xeb gatitej shtojca: {0}",
    "Failed to load plugin url: {0}": "S\u2019u arrit t\xeb ngarkohej URL shtojce: {0}",
    "Failed to load plugin: {0} from url {1}": "S\u2019u arrit t\xeb ngarkohej shtojca: {0} prej url-je {1}",
    "Failed to upload image: {0}": "S\u2019u arrit t\xeb ngarkohej figur\xeb: {0}",
    "File": "Kartel\xeb",
    "Find": "Gjej",
    "Find (if searchreplace plugin activated)": "Gjeni (n\xebse \xebsht\xeb aktivizuar shtojca p\xebr k\xebrkim dhe z\xebvend\xebsim)",
    "Find and Replace": "Gjej dhe Z\xebvend\xebso",
    "Find and replace...": "Gjeni dhe z\xebvend\xebsoni\u2026",
    "Find in selection": "Gjeni n\xeb p\xebrzgjedhje",
    "Find whole words only": "Gjej vet\xebm fjal\xeb t\xeb plota",
    "Flags": "Flamuj",
    "Focus to contextual toolbar": "Fokusi te panel kontekstual",
    "Focus to element path": "Fokusi te shteg elementi",
    "Focus to menubar": "Fokusi te shtyll\xeb menuje",
    "Focus to toolbar": "Fokusi te panel",
    "Font": "Shkronja",
    "Font size {0}": "Madh\xebsi fonti {0}",
    "Font sizes": "Madh\xebsit\xeb e fontit",
    "Font {0}": "Font {0}",
    "Fonts": "Shkronja",
    "Food and Drink": "Ushqim dhe Pije",
    "Footer": "Fundfaqe",
    "Format": "Format",
    "Format {0}": "Format {0}",
    "Formats": "Formate",
    "Fullscreen": "Mbulo ekranin",
    "G": "G",
    "General": "T\xeb p\xebrgjithshme",
    "Gray": "Gri",
    "Green": "E gjelb\xebr",
    "Green component": "Ngjyra e gjelb\xebr",
    "Groove": "Brazd\xeb",
    "Handy Shortcuts": "Shkurtore t\xeb Volitshme",
    "Header": "Kryefaqe",
    "Header cell": "Kutiz\xeb kryeje",
    "Heading 1": "Krye 1",
    "Heading 2": "Krye 2",
    "Heading 3": "Krye 3",
    "Heading 4": "Krye 4",
    "Heading 5": "Krye 5",
    "Heading 6": "Krye 6",
    "Headings": "Krye",
    "Height": "Lart\xebsi",
    "Help": "Ndihm\xeb",
    "Hex color code": "Kodi heksadecimal i ngjyr\xebs",
    "Hidden": "Fshehur",
    "Horizontal align": "Rreshto horizontalisht",
    "Horizontal line": "Vij\xeb horizontale",
    "Horizontal space": "Hapsir\xeb horizontale",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID-ja duhet t\xeb filloj me nj\xeb shkronj\xeb, pastaj t\xeb vazhdoj\xeb vet\xebm me shkronja, numra, viza, pika, dy pika ose n\xebnviza.",
    "Image is decorative": "Figura \xebsht\xeb p\xebr zbukurim",
    "Image list": "List\xeb figurash",
    "Image title": "Titull figure",
    "Image...": "Figur\xeb\u2026",
    "ImageProxy HTTP error: Could not find Image Proxy": "Gabim n\xeb ImageProxy HTTP: P\xebrfaq\xebsuesi nuk mund t\xeb gjindej",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Gabim n\xeb ImageProxy HTTP: URL-i i Image Proxy \xebsht\xeb gabim",
    "ImageProxy HTTP error: Rejected request": "Gabim n\xeb ImageProxy HTTP: K\xebrkesa u refuzua",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Gabim n\xeb ImageProxy HTTP: Gabim i panjohur n\xeb ImageProxy",
    "Increase indent": "Rritja shmangien e kryeradh\xebs",
    "Inline": "Renditur",
    "Insert": "Futni",
    "Insert Template": "P\xebrdor shabllonin",
    "Insert accordion": "Fut nj\xeb fizarmonik\xeb",
    "Insert column after": "Futni shtyll\xeb pas",
    "Insert column before": "Futni shtyll\xeb para",
    "Insert date/time": "Futni dat\xeb/koh\xeb",
    "Insert image": "Futni figur\xeb",
    "Insert link (if link plugin activated)": "Futni lidhje (n\xebse \xebsht\xeb aktivizuar shtojca e lidhjeve)",
    "Insert row after": "Futni rresht pas",
    "Insert row before": "Futni rresht para",
    "Insert table": "Futni tabel\xeb",
    "Insert template...": "Futni gjedhe\u2026",
    "Insert video": "Futni video",
    "Insert/Edit code sample": "Futni/P\xebrpunoni shembull kodi",
    "Insert/edit image": "Futni/p\xebrpunoni figur\xeb",
    "Insert/edit link": "Futni/p\xebrpunoni lidhje",
    "Insert/edit media": "Futni/p\xebrpunoni media",
    "Insert/edit video": "Futni/p\xebrpunoni video",
    "Inset": "Shtypur",
    "Invalid hex color code: {0}": "Kodi heksadecimal i ngjyr\xebs i pavlefsh\xebm: {0}",
    "Invalid input": "T\xeb dh\xebnat e pavlefshme",
    "Italic": "T\xeb pjerrta",
    "Justify": "P\xebrligje",
    "Keyboard Navigation": "L\xebvizje me Tastier\xeb",
    "Language": "Gjuh\xeb",
    "Learn more...": "M\xebsoni m\xeb tep\xebr\u2026",
    "Left": "Majtas",
    "Left to right": "Nga e majta n\xeb t\xeb djatht\xeb",
    "Light Blue": "Blu e \xc7el\xebt",
    "Light Gray": "Gri e \xc7el\xebt",
    "Light Green": "E gjelb\xebr e \xc7el\xebt",
    "Light Purple": "E purpur e \xc7el\xebt",
    "Light Red": "E kuqe e \xc7el\xebt",
    "Light Yellow": "E verdh\xeb e \xc7el\xebt",
    "Line height": "Lart\xebsi rreshti",
    "Link list": "List\xeb lidhjesh",
    "Link...": "Lidhni\u2026",
    "List Properties": "Veti Liste",
    "List properties...": "Veti liste\u2026",
    "Loading emojis...": "Emoji-t po ngarkohen...",
    "Loading...": "Duke u ngarkuar...",
    "Lower Alpha": "Alfa t\xeb Vogla",
    "Lower Greek": "Greke t\xeb Vogla",
    "Lower Roman": "Romake t\xeb Vogla",
    "Match case": "Si\xe7 \xebsht\xeb shkruar",
    "Mathematical": "Matematikore",
    "Media poster (Image URL)": "Postues mediash (URL Figure)",
    "Media...": "Media\u2026",
    "Medium Blue": "Blu e Mesme",
    "Medium Gray": "Gri e Mesme",
    "Medium Purple": "E purpurt e Mesme",
    "Merge cells": "P\xebrzieji kutizat",
    "Middle": "N\xeb mes",
    "Midnight Blue": "Blu Mesnate",
    "More...": "M\xeb tep\xebr\u2026",
    "Name": "Em\xebr",
    "Navy Blue": "Blu e err\xebt",
    "New document": "Dokument i ri",
    "New window": "Dritare e re",
    "Next": "Pasuesi",
    "No": "Jo",
    "No alignment": "Pa rreshtim",
    "No color": "Pa ngjyr\xeb",
    "Nonbreaking space": "Hap\xebsir\xeb e pandashme",
    "None": "Asnj\xeb",
    "Numbered list": "List\xeb e num\xebruar",
    "OR": "OSE",
    "Objects": "Objekte",
    "Ok": "Ok",
    "Open help dialog": "Hapni dialogun e ndihm\xebs",
    "Open link": "Hape lidhjen",
    "Open link in...": "Hape lidhje n\xeb:\u2026",
    "Open popup menu for split buttons": "Hapni menu fllusk\xeb p\xebr butona ndarjeje",
    "Orange": "Portokalli",
    "Outset": "Gung\xebt",
    "Page break": "Nd\xebrprerje faqeje",
    "Paragraph": "Paragraf",
    "Paste": "Ngjite",
    "Paste as text": "Ngjite si tekst",
    "Paste column after": "Ngjite kolon\xebn pas",
    "Paste column before": "Ngjite kolon\xebn p\xebrpara",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Ngjitjet tani b\xebhen n\xebn m\xebnyr\xebn \u201cthjesht tekst\u201d. L\xebnda tani do t\xeb ngjitet si tekst i thjesht\xeb, derisa ta \xe7aktivizoni k\xebt\xeb mund\xebsi.",
    "Paste or type a link": "Hidhni ose shtypni nj\xeb lidhje",
    "Paste row after": "Ngjite rreshtin pas",
    "Paste row before": "Ngjite rreshtin p\xebrpara",
    "Paste your embed code below:": "Ngjiteni kodin tuaj t\xeb trup\xebzimit m\xeb posht\xeb:",
    "People": "Persona",
    "Plugins": "Shtojca",
    "Plugins installed ({0}):": "Shtojca t\xeb instaluara ({0}):",
    "Powered by {0}": "Bazuar n\xeb {0}",
    "Pre": "Pre",
    "Preferences": "Parap\xeblqime",
    "Preformatted": "E paraformatuar",
    "Premium plugins:": "Shtojca me pages\xeb:",
    "Press the Up and Down arrow keys to resize the editor.": "Shtyp tastet me shigjeta Lart dhe Posht\xeb p\xebr ta ndryshuar madh\xebsin\xeb e programit.",
    "Press the arrow keys to resize the editor.": "Shtyp tastet me shigjeta p\xebr ta ndryshuar madh\xebsin\xeb e programit.",
    "Press {0} for help": "Shtyp {0} p\xebr ndihm\xeb",
    "Preview": "Paraparje",
    "Previous": "I m\xebparsh\xebmi",
    "Print": "Shtyp",
    "Print...": "Shtypeni\u2026",
    "Purple": "E purpurt",
    "Quotations": "Citime",
    "R": "R",
    "Range 0 to 255": "Gama nga 0 deri n\xeb 255",
    "Red": "E kuqe",
    "Red component": "Ngjyra e kuqe",
    "Redo": "Rib\xebje",
    "Remove": "Heq",
    "Remove color": "Hiqe ngjyr\xebn",
    "Remove link": "Hiqe lidhjen",
    "Replace": "Z\xebvend\xebsoje",
    "Replace all": "Z\xebvend\xebsoji krejt",
    "Replace with": "Z\xebvend\xebsoje me",
    "Resize": "Rip\xebrmasoje",
    "Restore last draft": "Rikthe skic\xebn e fundit",
    "Reveal or hide additional toolbar items": "Shfaq apo fshih artikuj shtes\xeb n\xeb shiritin e veglave",
    "Rich Text Area": "Zon\xeb me tekst t\xeb pasuruar",
    "Rich Text Area. Press ALT-0 for help.": "Fush\xeb Teksti t\xeb Pasur. P\xebr ndihm\xeb, shtypni ALT-0.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Fush\xeb Teksti t\xeb Pasur. p\xebr menu, shtypni tastet ALT-F9. P\xebr panel, shtypnis tastet ALT-F10r. P\xebr ndihm\xeb, shtypni ALT-0",
    "Ridge": "Kurriz",
    "Right": "Djathtas",
    "Right to left": "Nga e djathta n\xeb t\xeb majt\xeb",
    "Row": "Rresht",
    "Row clipboard actions": "Veprimet e clipboard-it n\xeb rreshta",
    "Row group": "Grup rreshtash",
    "Row header": "Kreu i rreshtit",
    "Row properties": "Veti rreshti",
    "Row type": "Lloj rreshti",
    "Rows": "Rreshta",
    "Save": "Ruaje",
    "Save (if save plugin activated)": "Ruaje (n\xebse \xebsht\xeb aktivizuar shtojca e ruajtjeve)",
    "Scope": "Fokus",
    "Search": "K\xebrko",
    "Select all": "P\xebrzgjidhe krejt",
    "Select...": "P\xebrzgjidhni\u2026",
    "Selection": "P\xebrzgjedhje",
    "Shortcut": "Shkurtore",
    "Show blocks": "Shfaqi blloqet",
    "Show caption": "Shfaq titull",
    "Show invisible characters": "Shfaqi shenjat e padukshme",
    "Size": "Madh\xebsi",
    "Solid": "E pa nd\xebrprer\xeb",
    "Source": "Burim",
    "Source code": "Kodi burim",
    "Special Character": "Shkronj\xeb Speciale",
    "Special character...": "Shenj\xeb speciale\u2026",
    "Split cell": "Ndaje kutiz\xebn",
    "Square": "Katror",
    "Start list at number": "Fillo list\xebn me numrin",
    "Strikethrough": "Hequrvije",
    "Style": "Stil",
    "Subscript": "Posht\xebshkrim",
    "Superscript": "Sip\xebrshkrim",
    "Switch to or from fullscreen mode": "Kaloni n\xeb ose dilni nga m\xebnyra \u201cSa t\xebr\xeb ekrani\u201c",
    "Symbols": "Simbole",
    "System Font": "Shkronja Sistemi",
    "Table": "Tabel\xeb",
    "Table caption": "Shpjegimi i tabel\xebs",
    "Table properties": "Veti tabele",
    "Table styles": "Pamja e tabel\xebs",
    "Template": "Gjedhe",
    "Templates": "Gjedhe",
    "Text": "Tekst",
    "Text color": "Ngjyr\xeb teksti",
    "Text color {0}": "Tekst me ngjyr\xeb t\xeb {0}",
    "Text to display": "Tekst p\xebr t\u2019u shfaqur",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "URL-ja q\xeb dhat\xeb duket se \xebsht\xeb adres\xeb email. Doni t\xeb shtohet parashtesa e domosdoshme mailto: ?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "URL-ja q\xeb dhat\xeb duket se \xebsht\xeb lidhje e jashtme. Doni ti shtohet parashtesa e domosdoshme https:// ?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "URL-ja q\xeb dhat\xeb duket t\xeb jet\xeb nj\xeb lidhje e jashtme. Doni ti shtohet parashtesa e domosdoshme https:// ?",
    "Title": "Titull",
    "To open the popup, press Shift+Enter": "Q\xeb t\xeb hapet flluska, shtypni tastet Shift+Enter",
    "Toggle accordion": "L\xebviz fizarmonik\xebn",
    "Tools": "Mjete",
    "Top": "N\xeb krye",
    "Travel and Places": "Udh\xebtim dhe Vende",
    "Turquoise": "E bruzt\xeb",
    "Underline": "N\xebnvij\xeb",
    "Undo": "Zhb\xebje",
    "Upload": "Ngarkoje",
    "Uploading image": "Duke ngarkuar foton",
    "Upper Alpha": "Alfa t\xeb M\xebdha",
    "Upper Roman": "Romake t\xeb\xa0M\xebdha",
    "Url": "Url",
    "User Defined": "P\xebrcaktuar Nga P\xebrdoruesi",
    "Valid": "E vlefshme",
    "Version": "Versioni",
    "Vertical align": "Rreshto vertikalisht",
    "Vertical space": "Hapsir\xeb vertikale",
    "View": "Shihni",
    "Visual aids": "Ndihm\xebs pamor\xeb",
    "Warn": "Sinjalizoje",
    "White": "E bardh\xeb",
    "Width": "Gjer\xebsi",
    "Word count": "Num\xebr fjal\xebsh",
    "Words": "Fjal\xeb",
    "Words: {0}": "Fjal\xeb: {0}",
    "Yellow": "E verdh\xeb",
    "Yes": "Po",
    "You are using {0}": "Po p\xebrdorni {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Keni ndryshime t\xeb paruajtura, jeni i sigurt se doni t\xeb ikni prej k\xebtej?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Shfletuesi juaj nuk e lejon qasjen e drejtp\xebrdrejt\xeb n\xeb clipboard. Ju lutemi, p\xebrdorni shkurtoret Ctrl+X/C/V p\xebr ndryshe.",
    "alignment": "drejtim",
    "austral sign": "shenj\xeb australi",
    "cedi sign": "shenj\xeb cedi",
    "colon sign": "shenj\xeb dy pika",
    "cruzeiro sign": "shenj\xeb kruzeiroje",
    "currency sign": "simbol monedhe",
    "dollar sign": "simbol dollari",
    "dong sign": "shenj\xeb dongu",
    "drachma sign": "shenj\xeb drahme",
    "euro-currency sign": "simbol euroje",
    "example": "shembull",
    "formatting": "formatim",
    "french franc sign": "shenj\xeb frangu fr\xebng",
    "german penny symbol": "shenj\xeb peni gjerman",
    "guarani sign": "shenj\xeb guaranie",
    "history": "historik",
    "hryvnia sign": "shenj\xeb hrivniaje",
    "indentation": "shmangie kryeradhe",
    "indian rupee sign": "shenj\xeb rupie indiane",
    "kip sign": "shenj\xeb kipi",
    "lira sign": "shenj\xeb sterline",
    "livre tournois sign": "shenj\xeb lire Turi",
    "manat sign": "shenj\xeb manati",
    "mill sign": "shenj\xeb mili",
    "naira sign": "shenj\xeb nairaje",
    "new sheqel sign": "shenj\xeb shekeli t\xeb ri",
    "nordic mark sign": "shenj\xeb marke nordike",
    "peseta sign": "shenj\xeb pesete",
    "peso sign": "shenj\xeb peso",
    "ruble sign": "shenj\xeb ruble",
    "rupee sign": "shenj\xeb rupie",
    "spesmilo sign": "shenj\xeb spesmiloje",
    "styles": "stile",
    "tenge sign": "shenj\xeb tenge",
    "tugrik sign": "shenj\xeb tugriku",
    "turkish lira sign": "shenj\xeb lire turke",
    "won sign": "shenj\xeb uoni",
    "yen character": "shenj\xeb jeni",
    "yen/yuan character variant one": "shenja jen/juan n\xeb variantin nj\xeb",
    "yuan character": "shenj\xeb juani",
    "yuan character, in hong kong and taiwan": "shenja e juanit, n\xeb Hong Kong dhe Tajvan",
    "{0} characters": "{0} shenja",
    "{0} columns, {1} rows": "{0} kolona, {1} rreshta",
    "{0} words": "{0} fjal\xeb"
});